import React, { useEffect, useState } from "react";
import Store from "./Store";
import { Grid } from "@mui/material";
import { db } from "../../firebase";
import { query, collection, getDocs, orderBy } from "firebase/firestore";
import ShoppingCart from "./ShoppingCart";
import LocationMenu from "./Location";

const Cart = () => {
  const [data, setData] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [id, setId] = useState("");
  const [mainview, setMainview] = useState(false);
  const [location, setLocation] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = collection(db, "products");
      const q = query(ref, orderBy("title", "desc"));
      const data = await getDocs(q);
      setData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    fetchData();
  }, []);

  const onAdd = (product) => {
    const exist = cartItems.find((x) => x[0] === product[0]);

    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x[0] === product[0] ? { ...exist, qty: exist.qty + 1 } : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, qty: 1 }]);
    }
  };

  const onRemove = (product) => {
    const exist = cartItems.find((x) => x[0] === product[0]);
    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x[0] !== product[0]));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x[0] === product[0] ? { ...exist, qty: exist.qty - 1 } : x
        )
      );
    }
  };
  return (
    <>
      {mainview ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Store
              data={data}
              onAdd={onAdd}
              id={id}
              setId={setId}
              location={location}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ShoppingCart
              cartItems={cartItems}
              onAdd={onAdd}
              onRemove={onRemove}
              location={location}
              data={data}
            />
          </Grid>
        </Grid>
      ) : (
        <LocationMenu
          location={location}
          setLocation={setLocation}
          setMainview={setMainview}
        />
      )}
    </>
  );
};

export default Cart;
